<template>
    <bareme-etape-2></bareme-etape-2>
</template>

<script>


import BaremeEtape2 from '@/components/bareme/etapes/Etape2.vue';

export default {
  name: 'BaremeResultat',
  components: { BaremeEtape2 },
};
</script>

<style scoped>
    /deep/ .panel:last-child {
        margin-bottom: 20px;
    }
</style>
